<div class="p-6" style="min-width: 300px;">

    <!-- Title -->
    <h2 class="text-center font-bold text-xl mb-5 orange-text">
        Add {{ distributorTypeLabel }}
    </h2>

    <div class="flex flex-col justify-center items-center gap-4">

        <!-- Mobile Number (all types) -->
        <div class="flex flex-col" style="width: 320px;">
            <div class="card-input flex items-center text-xs py-2"
                    [class.border-red-500]="isInvalid('mobileNumber')"
                    [style.border-color]="isInvalid('mobileNumber') ? '#e3342f' : ''">
                <span class="text-xs w-130-px font-semibold">Mobile Number:</span>
                <input
                    [formControl]="$any(form.controls['mobileNumber'])"
                    type="text"
                    placeholder="Mobile Number"
                    class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3"
                    (blur)="formatMobileNumber()"
                >
            </div>
            <span *ngIf="getFieldError('mobileNumber')"
                class="font-semibold mt-1"
                style="color: #e3342f; font-size: 10px;">
                {{ getFieldError('mobileNumber') }}
            </span>
        </div>

        <!-- Region (regional only) -->
        <div *ngIf="isRegional" class="flex flex-col" style="width: 320px;">
            <div class="card-input flex items-center text-xs py-2"
                    [class.border-red-500]="isInvalid('region')"
                    [style.border-color]="isInvalid('region') ? '#e3342f' : ''">
                <span class="text-xs w-130-px font-semibold">Region:</span>
                <input
                    [formControl]="$any(form.controls['region'])"
                    type="text"
                    placeholder="Region"
                    class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3"
                >
            </div>
            <span *ngIf="getFieldError('region')"
                class="font-semibold mt-1"
                style="color: #e3342f; font-size: 10px;">
                {{ getFieldError('region') }}
            </span>
        </div>

        <!-- Province (regional + provincial) -->
        <div *ngIf="isProvincial" class="flex flex-col" style="width: 320px;">
            <div class="card-input flex items-center text-xs py-2"
                    [class.border-red-500]="isInvalid('province')"
                    [style.border-color]="isInvalid('province') ? '#e3342f' : ''">
                <span class="text-xs w-130-px font-semibold">Province:</span>
                <input
                    [formControl]="$any(form.controls['province'])"
                    type="text"
                    placeholder="Province"
                    class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3"
                >
            </div>
            <span *ngIf="getFieldError('province')"
                class="font-semibold mt-1"
                style="color: #e3342f; font-size: 10px;">
                {{ getFieldError('province') }}
            </span>
        </div>

        <!-- Description (all types) -->
        <div class="flex flex-col" style="width: 320px;">
            <div class="card-input flex items-center text-xs py-2"
                    [class.border-red-500]="isInvalid('description')"
                    [style.border-color]="isInvalid('description') ? '#e3342f' : ''">
                <span class="text-xs w-130-px font-semibold">Description:</span>
                <input
                    [formControl]="$any(form.controls['description'])"
                    type="text"
                    placeholder="Description"
                    class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3"
                >
            </div>
            <span *ngIf="getFieldError('description')"
                class="font-semibold mt-1"
                style="color: #e3342f; font-size: 10px;">
                {{ getFieldError('description') }}
            </span>
        </div>

    </div>

    <!-- Action buttons -->
    <div class="flex items-center justify-center gap-3 mt-6">
        <span
            [style.cursor]="!isFormValid ? 'not-allowed' : 'pointer'"
            [matTooltip]="!isFormValid ? 'Please fill in all required fields' : ''"
            [matTooltipDisabled]="isFormValid"
            matTooltipPosition="left"
            matTooltipClass="custom-orange-tooltip"
        >
            <button
                (click)="store()"
                [disabled]="!isFormValid"
                class="uppercase custom-btn power-btn3 disabled active font-semibold text-sm"
                style="padding: 8px 12px;">
                Submit
            </button>
        </span>
        <button
            (click)="close()"
            class="uppercase custom-btn power-btn3 font-semibold text-sm"
            style="padding: 8px 12px;">
            Cancel
        </button>
    </div>

</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>